var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProblemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information",
    clipPath: "url(#clip0_1454_413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 18C13.9747 18 18 13.9744 18 9C18 4.02528 13.9744 -1.55542e-06 9 -1.12054e-06C4.02529 -6.8564e-07 6.85671e-07 4.02564 1.12054e-06 9C1.55545e-06 13.9747 4.02567 18 9 18ZM9 1.40625C13.1974 1.40625 16.5937 4.80287 16.5937 9C16.5937 13.1974 13.1971 16.5938 9 16.5938C4.80259 16.5938 1.40625 13.1971 1.40625 9C1.40625 4.80259 4.80291 1.40625 9 1.40625Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 10.4648C9.38834 10.4648 9.70312 10.1501 9.70312 9.76172L9.70312 5.23384C9.70312 4.8455 9.38834 4.53072 9 4.53072C8.61166 4.53072 8.29687 4.84554 8.29687 5.23387L8.29688 9.76172C8.29688 10.1501 8.61166 10.4648 9 10.4648Z",
    fill: "#29185E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 11.3262C8.47576 11.3262 8.05078 11.7512 8.05078 12.2754C8.05078 12.7996 8.47576 13.2246 9 13.2246C9.52424 13.2246 9.94922 12.7996 9.94922 12.2754C9.94922 11.7512 9.52424 11.3262 9 11.3262Z",
    fill: "#29185E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1454_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18 18) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemIcon);
export default __webpack_public_path__ + "static/media/problem-icon.4d911627084dfd59a6cf7af49557af6c.svg";
export { ForwardRef as ReactComponent };